import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Is my wallet safe?",
    answer: "Absolutely. We use WalletConnect for read-only access to your public address. We never request trading permissions, withdrawal access, or private keys. Your funds remain completely in your control at all times."
  },
  {
    question: "How is Sharpe Ratio calculated?",
    answer: "We calculate Sharpe Ratio from your account value history fetched from Hyperliquid. We compute the mean and standard deviation of your returns over the selected time period. A ratio above 1.0 is generally considered good, above 2.0 is excellent."
  },
  {
    question: "What data do you store?",
    answer: "We store your public wallet address, trading fills (price, size, time), and account value history. This data is used to compute your metrics. We never store private keys or request trading permissions."
  },
  {
    question: "Can I use Sharpexio without creating an account?",
    answer: "Yes! You can connect your wallet and view your metrics without signing up. Creating an account lets you save your history and access your data across devices."
  },
  {
    question: "How often is data refreshed?",
    answer: "Free users can refresh once per day. Pro users get unlimited refreshes. Data is fetched directly from Hyperliquid's Info API."
  },
  {
    question: "What time ranges are available?",
    answer: "Free users get access to the last 30 days. Pro users can access up to 365 days or all available trading history."
  },
  {
    question: "Do you support subaccounts?",
    answer: "Yes, you can analyze any Hyperliquid address including subaccounts. Just connect the wallet that controls the address you want to analyze."
  },
  {
    question: "Is this financial advice?",
    answer: "No. Sharpexio provides analytics and metrics for informational purposes only. Past performance does not guarantee future results. Always do your own research and trade responsibly."
  }
];

export const FAQ = () => {
  return (
    <section className="py-24 md:py-32 relative bg-card/30">
      <div className="container px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Frequently asked <span className="text-primary">questions</span>
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Everything you need to know about Sharpexio.
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border border-border rounded-lg bg-card/50 px-6 data-[state=open]:bg-card"
              >
                <AccordionTrigger className="text-left hover:no-underline py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
